import MatchItemsModal from './MatchItemsModal';

export type { MatchItemsModalProps } from './MatchItemsModal';
export default MatchItemsModal;
